export const ORDER_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Datos guardados con éxito!",
};

export const ORDER_MESSAGES_ERROR = {
  SAVE_ERROR: "Oops! algo salió mal, inténtalo de nuevo más tarde.",
  FETCH_ERROR: "Oops! algo salió mal, inténtalo de nuevo más tarde.",
};
